import { ReactNode } from 'react';
import './StatisticListCard.scss';

interface IStatisticListCardProps {
  children: ReactNode | ReactNode[];
  value: string;
  highlighted?: boolean
  onClick?: () => void
}

const StatisticListCard = ({ children, value, highlighted, onClick }: IStatisticListCardProps) => {
  return (
    <div className={`statistics-list-card ${highlighted ? 'highlighted' : ''}`} onClick={onClick}>
      <div className='statistics-list-card-label'>{children}</div>
      <p className='statistics-list-card-value'>{value}</p>
    </div>
  );
};

export default StatisticListCard;
